<div class="container">
  <div class="top-bar">
    <!-- SVG by Zendesk Garden on icon-icons.com -->
    <svg
      class="multiline-button clickable"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      (click)="toggleMultilineMode()"
      [class.active]="multilineMode"
      [matTooltip]="getMultilineTooltip()"
      matTooltipPosition="above"
    >
      <path
        stroke-linecap="round"
        stroke-width="2"
        d="M2 4h8M2 1h8M2 7h8m-8 3h3.5"
      />
    </svg>

    <!-- SVG by Free Preloaders on freeicons.io -->
    <svg
      class="alias-button clickable"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      (click)="toggleAliasMode()"
      [class.active]="aliasMode"
      [matTooltip]="getAliasTooltip()"
      matTooltipPosition="above"
    >
      <path
        d="M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
      />
    </svg>

    <input
      #aliasInput
      [@visibility]="getAliasVisibilityState()"
      class="alias-input"
      [placeholder]="aliasPlaceholder"
      spellcheck="false"
      autocomplete="off"
      (input)="trimAliasName($event.target)"
      [matTooltip]="getAliasInputTooltip()"
      matTooltipPosition="above"
    />

    <div class="flex-spacer"></div>

    <!-- SVG by icon king1 on freeicons.io -->
    <svg
      [@visibility]="getRefreshVisibilityState()"
      class="refresh-button clickable"
      style="enable-background: new 0 0 32 32"
      stroke-width="0"
      viewBox="0 0 32 32"
      xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      (click)="refreshMultilineOutput()"
      [matTooltip]="getRefreshTooltip()"
      matTooltipPosition="above"
    >
      <path
        d="M28,16c-1.219,0-1.797,0.859-2,1.766C25.269,21.03,22.167,26,16,26c-5.523,0-10-4.478-10-10S10.477,6,16,6  c2.24,0,4.295,0.753,5.96,2H20c-1.104,0-2,0.896-2,2s0.896,2,2,2h6c1.104,0,2-0.896,2-2V4c0-1.104-0.896-2-2-2s-2,0.896-2,2v0.518  C21.733,2.932,18.977,2,16,2C8.268,2,2,8.268,2,16s6.268,14,14,14c9.979,0,14-9.5,14-11.875C30,16.672,28.938,16,28,16z"
      />
    </svg>

    <div class="copy-button-backdrop">
      <!-- SVG by Catalin Fertu on flaticon.com -->
      <svg
        class="copy-button clickable"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 699.428 699.428"
        style="enable-background: new 0 0 699.428 699.428"
        (click)="copyToClipboard()"
        [matTooltip]="getCopyTooltip()"
        matTooltipPosition="above"
      >
        <path
          d="M502.714,0.678C500.004,0.678,240.428,0,240.428,0C194.178,0,153,42.425,153,87.429l-25.267,0.59c-46.228,0-84.019,41.834-84.019,86.838V612c0,45.004,41.179,87.428,87.429,87.428H459c46.249,0,87.428-42.424,87.428-87.428h21.857c46.25,0,87.429-42.424,87.429-87.428v-349.19L502.714,0.678z M459,655.715H131.143c-22.95,0-43.714-21.441-43.714-43.715V174.857c0-32.523,26.753-43.714,65.571-43.714v393.429C153,569.576,194.178,612,240.428,612c0,0,236.975-0.24,262.482-0.24C502.91,638.295,485.513,655.715,459,655.715z M502.714,459.24H306c-12.065,0-21.857-9.77-21.857-21.836c0-12.064,9.792-21.834,21.857-21.834h196.714c12.065,0,21.857,9.77,21.857,21.834C524.571,449.471,514.779,459.24,502.714,459.24z M502.714,350.064H306c-12.065,0-21.857-9.771-21.857-21.835c0-12.065,9.792-21.835,21.857-21.835h196.714c12.065,0,21.857,9.77,21.857,21.835C524.571,340.272,514.779,350.064,502.714,350.064z M546.428,174.857c-23.277,0-43.714-21.004-43.714-43.714c0,0,0-44.283,0-86.751v-0.044L612,174.857H546.428z"
        />
      </svg>
    </div>
  </div>

  <div class="output-box-container">
    <div class="output-box-background"></div>
    <input
      #outputBox
      readonly
      class="output-box"
      spellcheck="false"
      [value]="getOutput()"
    />
    <ng-container *ngIf="multilineMode">
      <commands-ui-multiline-output
        #multilineOutput
        [commandString]="commandString"
        (deactivate)="multilineMode = false"
      ></commands-ui-multiline-output>
    </ng-container>
  </div>
</div>
